// Centralised, easy-to-edit constants for the Lidera con Voz Propia landing.
// Replace Stripe links or image URLs here — nothing else in the codebase needs to change.

export const STRIPE_LINKS = {
  general: "https://buy.stripe.com/5kQbJ20Ex6ek8iM4o61gs0K",
  vip: "https://buy.stripe.com/14A8wQ3QJgSYdD6cUC1gs0J",
};

export const EVENT = {
  date: "15 de octubre",
  city: "Sevilla",
  editionLabel: "Edición Primer Aniversario",
  seatsGeneral: 11,
  seatsVip: 3,
  // Availability flags for the two modalities:
  //   - vipSoldOut: VIP is fully sold out for this edition (no more VIP tickets).
  //   - generalBatchClosed: the special second batch of the General Pass is
  //     closed. A final batch of tickets will open in the coming weeks —
  //     waitlist is available in the meantime.
  //
  // Set BOTH to false when a new batch is available; set the promo fields
  // (code / windowStart / windowEnd) accordingly to surface the promo block.
  generalBatchClosed: false,
  vipSoldOut: true,
  // Promo code / enrollment window — reactivate when a new batch is announced.
  // Leave empty strings ("") when no active promo is running.
  code: "",
  windowStart: "",
  windowEnd: "",
};

// Replace these URLs with the real photos when available.
// Wrap with the same aspect ratio containers so the layout does not shift.
export const IMAGES = {
  heroBg:
    "https://customer-assets.emergentagent.com/job_lidera-voz-propia/artifacts/ci1vjnpv_IMG_1010.webp",
  communityPhoto:
    "https://customer-assets.emergentagent.com/job_lidera-voz-propia/artifacts/mrak7sxd_IMG_1072.webp",
  venuePhoto: "",
  speakerLula: "",
  speakerFrancisca: "",
  speakerKarla:
    "https://customer-assets-agu9un31.emergentagent.net/job_lidera-voz-propia/artifacts/mkufruiv_82e956c5-c0bb-49c3-a2c8-b43c4529d1dc.jpeg",
  speakerVeronica:
    "https://customer-assets-agu9un31.emergentagent.net/job_lidera-voz-propia/artifacts/j0inqwrr_Ver%C3%B3nica%20Chumillas.jpeg",
  speakerAna:
    "https://customer-assets-agu9un31.emergentagent.net/job_lidera-voz-propia/artifacts/pm45cmpo_Retrato%20elegante%20entre%20cer%C3%A1micas%20azules.png",
  founderEsther: "",
};
